import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=7a86cf8b&scoped=true&"
import script from "./Totals.vue?vue&type=script&lang=js&"
export * from "./Totals.vue?vue&type=script&lang=js&"
import style0 from "./Totals.vue?vue&type=style&index=0&id=7a86cf8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a86cf8b",
  null
  
)

export default component.exports